import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
export default function Login() {
  const { login } = useAuth();
  const [phone,    setPhone]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await login(phone, password); }
    catch (err) { setError(err.response?.data?.error || err.message || 'خطأ في تسجيل الدخول'); }
    finally { setLoading(false); }
  };
  return (
    <div style={S.page}>
      <div style={S.top}>
        <div style={S.logo}>🛵</div>
        <h1 style={S.title}>بسرعة</h1>
        <p style={S.sub}>بوابة الطيارين</p>
      </div>
      <div style={S.card}>
        <form onSubmit={handleSubmit}>
          <div style={S.field}>
            <label style={S.label}>رقم الهاتف</label>
            <input style={S.input} type="tel" value={phone} onChange={e=>setPhone(e.target.value)} placeholder="01xxxxxxxxx" required dir="ltr"/>
          </div>
          <div style={S.field}>
            <label style={S.label}>كلمة المرور</label>
            <input style={S.input} type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required/>
          </div>
          {error && <div style={S.error}>{error}</div>}
          <button style={S.btn} type="submit" disabled={loading}>
            {loading ? '⏳ جاري الدخول...' : '🚀 دخول'}
          </button>
        </form>
      </div>
      <p style={S.note}>* هذا التطبيق للطيارين المعتمدين فقط</p>
    </div>
  );
}
const S = {
  page:  { minHeight:'100vh', background:'linear-gradient(160deg,#0f0c29,#302b63,#24243e)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'20px', direction:'rtl' },
  top:   { textAlign:'center', marginBottom:'30px' },
  logo:  { fontSize:'64px', marginBottom:'10px' },
  title: { color:'#fff', fontSize:'36px', fontWeight:'900', margin:'0 0 5px', letterSpacing:'2px' },
  sub:   { color:'rgba(255,255,255,0.6)', fontSize:'15px', margin:0 },
  card:  { background:'rgba(255,255,255,0.07)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'20px', padding:'30px', width:'100%', maxWidth:'380px' },
  field: { marginBottom:'16px' },
  label: { display:'block', color:'rgba(255,255,255,0.7)', fontSize:'13px', marginBottom:'6px', fontWeight:'bold' },
  input: { width:'100%', padding:'14px', background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.2)', borderRadius:'10px', color:'#fff', fontSize:'16px', boxSizing:'border-box', outline:'none' },
  btn:   { width:'100%', padding:'15px', background:'linear-gradient(135deg,#f093fb,#f5576c)', border:'none', borderRadius:'12px', color:'#fff', fontSize:'17px', fontWeight:'bold', cursor:'pointer', marginTop:'8px' },
  error: { background:'rgba(231,76,60,0.2)', border:'1px solid rgba(231,76,60,0.4)', borderRadius:'8px', padding:'10px', color:'#ff6b6b', fontSize:'14px', marginBottom:'12px', textAlign:'center' },
  note:  { color:'rgba(255,255,255,0.3)', fontSize:'12px', marginTop:'20px', textAlign:'center' },
};
